module.exports = __webpack_public_path__ + "img/shopping-1.af419cee.png";